import { render, staticRenderFns } from "./BuscarDocFiscalFilterBar.vue?vue&type=template&id=254ffb5b"
import script from "./BuscarDocFiscalFilterBar.vue?vue&type=script&lang=js"
export * from "./BuscarDocFiscalFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports